import React, { useState } from "react";
import _, { get, isEmpty } from "lodash";
import { AccessTime } from "@mui/icons-material";
import { LinearProgress } from "@mui/material";
import { NOW } from "../../utils/constants";
import getPickupTimesTranslatedInSelectForm from "../../utils/getPickupTimesTranslatedInSelectForm";
import Button from "../Button";
import SelectInput from "../Inputs/Select";
import OrderCalendar from "../OrderCalendar";

const PickupTimePopup = ({
  appStyles,
  T,
  pickupTimes,
  order,
  currentBranch,
  selectedServingOption,
  setPickupTime,
  setFutureServingTime,
  branchesAvailability,
  onClose,
}) => {
  const [openCalendar, setOpenCalendar] = useState(false);

  const offersPickupTime =
    selectedServingOption && selectedServingOption.offersPickupTime;

  const enableFutureOrders =
    currentBranch &&
    !currentBranch.disableFutureOrders &&
    selectedServingOption.enableFutureOrders;

  const branchAvailability = branchesAvailability[currentBranch.id];

  const isBranchNotAvailable =
    pickupTimes.error &&
    pickupTimes.error === "BRANCH_AVAILABILITY_NOT_FOUND";

  const pickupTimesInSelectForm = getPickupTimesTranslatedInSelectForm({
    pickupTimes,
    T,
  });

  const handleSetPickupTime = (pickupTime) => {
    setPickupTime({ pickupTime, timeZoneStr: currentBranch.timeZoneStr });
  };

  const handleDaySelected = (selectedDate, { disabled }) => {
    setOpenCalendar(false);
    if (disabled) {
      return;
    }
    setFutureServingTime({
      futureServingDate: selectedDate,
      timeZoneStr: currentBranch.timeZoneStr,
      branchId: currentBranch.id,
    });
  };

  const canContinue = Boolean(order.pickupTime);

  return (
    <React.Fragment>
      <AccessTime
        style={{ color: appStyles.accentColor, fontSize: 40, display: "block", margin: "0 auto" }}
      />
      <h2 style={{ textAlign: "center", color: appStyles.accentColor }}>
        {T(`Select ${selectedServingOption.servingOptionTag} Time`)}
      </h2>
      <div style={{ color: get(appStyles, "Card.color") }}>
        <span style={{ ...appStyles.CardContent, display: "block", textAlign: "center" }}>
          {T("When would you like your order?")}
        </span>
      </div>
      {enableFutureOrders && offersPickupTime && (
        <OrderCalendar
          T={T}
          appStyles={appStyles}
          servingOptionTag={selectedServingOption.servingOptionTag}
          servingOptionType={selectedServingOption.type}
          openCalendar={openCalendar}
          onDaySelected={handleDaySelected}
          onInputClick={() => setOpenCalendar(!openCalendar)}
          selectedDate={order.futureServingTime}
          branchAvailability={branchAvailability}
          timeZone={currentBranch.timeZoneStr}
        />
      )}
      {!isBranchNotAvailable && offersPickupTime && (
        <div style={{ marginTop: 10 }}>
          <div>
            {T(`${selectedServingOption.servingOptionTag} ${T("Time")}`)}:
          </div>
          {pickupTimes.loading ? (
            <LinearProgress
              style={{
                color: appStyles.accentColor,
                margin: "20px 0",
              }}
            />
          ) : (
            <SelectInput
              appStyles={appStyles}
              style={{ marginTop: "6px", width: "100%" }}
              onChange={handleSetPickupTime}
              value={
                order.pickupTime === NOW
                  ? pickupTimesInSelectForm[0]?.value
                  : order.pickupTime
              }
              options={pickupTimesInSelectForm || []}
              placeholder={
                !order.pickupTime &&
                (pickupTimesInSelectForm && !isEmpty(pickupTimesInSelectForm)
                  ? T("Please Select a Time")
                  : T(
                      `No more ${selectedServingOption.servingOptionTag} times on this day`
                    ))
              }
            />
          )}
        </div>
      )}
      <Button
        appStyles={appStyles}
        centered
        style={{ marginTop: 16, ...(!canContinue ? { backgroundColor: "#cccccc" } : {}) }}
        onClick={canContinue ? onClose : () => {}}
      >
        {T("Continue order")}
      </Button>
    </React.Fragment>
  );
};

export default PickupTimePopup;
